import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    setPublishStatus: host + 'v3/zyk/setPublishStatus',//公开设置
    savePicture:host + "v3/zyk/savePicture",//保存图片
    saveVideo:host+ 'v3/zyk/saveVideo',
    saveAudio:host+'v3/zyk/saveAudio',
    saveOtherFile:host+'v3/zyk/saveOtherFile',
    setShareRight:host+'v3/zyk/setShareRight',
    saveAll:host +'/v3/zyk/saveAll',
};

export const savePicture = (body, callBack) => {  //保存图片
    request({url:Apis.savePicture, body, method:"post", callBack});
};
export const saveVideo = (body, callBack) => {  //保存视频
    request({url:Apis.saveVideo, body, method:"post", callBack});
};
export const saveAudio = (body, callBack) => {  //保存音频
    request({url:Apis.saveAudio, body, method:"post", callBack});
};
export const saveOtherFile = (body, callBack) => {  //保存其他文件
    request({url:Apis.saveOtherFile, body, method:"post", callBack});
};
export const setShareRight = (body, callBack) => {  //分享
    request({url:Apis.setShareRight, body, method:"post", callBack});
};
export const saveAll = (body, callBack) => {  //分享
    request({url:Apis.saveAll, body, method:"post", callBack});
};

export const removeFromDirecotry = (directoryId,md5,callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/storage/removeFromDirecotry";
    request({url, body:{directoryId,md5}, method:"post", callBack});
};

export const getStorageDirectory = (storageDirectoryId,callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/storage/getStorageDirectory";
    request({url, body:{storageDirectoryId}, method:"post", callBack});
};
export const collection = (resourceIds,callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/zyk/collection/add";
    request({url, body:{resourceIds}, method:"post", callBack});
};


export const filesToDirectory = (directoryId,md5s, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/storage/filesToDirectory";
    request({url, body:{directoryId,md5s}, method:"post", callBack});
};
export const exist = (url,type, callBack)=> {
    let _url = "/cm-sites-" + applicationName() + "/zyk/upload/exist";
    request({url:_url, body:{url,type}, method:"post", callBack});
};
export const moveByDirectoryIdsAndFileIds = (directoryIds,fileIds,targetId, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/cm-sites-pms/storage/moveByDirectoryIdsAndFileIds";
    request({url, body:{directoryIds,fileIds,targetId}, method:"post", callBack});
};

export const getresourcesList = (storageDirectoryId, callBack,sortType='',sortCondition='',)=> {
    let url = "/cm-sites-" + applicationName() + "/v3/zyk/storageList";
    request({url, body:{storageDirectoryId,sortType,sortCondition}, method:"post", callBack});
};
export const deptAll = (callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/dept/all";
    request({url, method:"post", callBack});
};

export const deptUserAll = (callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/user/getDeptTreeUser";
    request({url, callBack});
};

export const userList = (start,size,deptId,callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/user/list";
    request({url, body:{start,size,deptId}, callBack});
};
export const storageDirectorySize = (storageDirectoryId,callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/storage/storageDirectorySize";
    request({url, body:{storageDirectoryId}, callBack});
};
export const getUserListArray = (queryStr,callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/user/list";
    request({url, body:{queryStr}, method:"post", callBack});
};